import React from 'react';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';

function CalculatorView({
  items,
  selectedList,
  currentWeight,
  unitWeight,
  currentProductName,
  onSearch,
  onWeightChange,
  onUnitChange,
  onProductNameChange,
  onAddToBucket,
  onRemoveFromBucket,
  onCalculate,
}) {
  return (
    <main className="main-container">
      <div className="page-title">
        <h1>New Recipe</h1>
        <p>Add your ingredients and get the cost</p>
      </div>

      <div className="card">
        <div className="card-header">
          <span className="step-badge">1</span>
          <h2>Product Name</h2>
        </div>
        <input
          className="input-field"
          type="text"
          placeholder="e.g. Chocolate Chip Cookies"
          value={currentProductName}
          onChange={onProductNameChange}
        />
      </div>

      <div className="card">
        <div className="card-header">
          <span className="step-badge">2</span>
          <h2>Add Ingredients</h2>
        </div>
        <label className="field-label">Search ingredient</label>
        <ReactSearchAutocomplete
          items={items}
          placeholder="e.g. butter"
          onSelect={onSearch}
          autoFocus
          styling={{
            borderRadius: '8px',
            border: '1px solid #d1d5db',
            boxShadow: 'none',
            fontSize: '15px',
            height: '46px',
            zIndex: 10,
          }}
        />
        <label className="field-label ingredient-weight-label">Weight used (grams)</label>
        <input
          className="input-field"
          type="number"
          placeholder="e.g. 250"
          value={currentWeight}
          onChange={onWeightChange}
        />
        <button className="btn btn-secondary" onClick={onAddToBucket}>
          + Add to List
        </button>
      </div>

      {selectedList.length > 0 && (
        <div className="card">
          <h2 className="card-title">Ingredients Added</h2>
          <div className="table-wrap">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Ingredient</th>
                  <th>Weight</th>
                  <th>Est. Cost</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {selectedList.map((item, i) => {
                  const itemCost = ((item.price / item.vol) * item.weight).toFixed(2);
                  return (
                    <tr key={i}>
                      <td>{item.name}</td>
                      <td>{item.weight}g</td>
                      <td>&#8377;{itemCost}</td>
                      <td>
                        <button className="remove-btn" onClick={() => onRemoveFromBucket(i)}>
                          &#10005;
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div className="card">
        <div className="card-header">
          <span className="step-badge">3</span>
          <h2>Unit Size</h2>
        </div>
        <label className="field-label">Weight per unit (grams)</label>
        <p className="field-hint">e.g. if each cookie weighs 20g, enter 20</p>
        <input
          className="input-field"
          type="number"
          placeholder="e.g. 20"
          value={unitWeight}
          onChange={onUnitChange}
        />
      </div>

      <button
        className="btn btn-primary calculate-btn"
        onClick={onCalculate}
        disabled={selectedList.length === 0 || !unitWeight}
      >
        Calculate Cost
      </button>
    </main>
  );
}

export default CalculatorView;
